document.addEventListener("click", function(e) {
  let el = e.target.closest("a");

  if (!el) return;

  const href = el.getAttribute("href");

  if (!href || href.charAt(0) === "#") return;

  // Pathname del link risolto sul dominio corrente (funziona su US e UK)
  let url;
  try {
    url = new URL(href, window.location.href);
  } catch (err) {
    return;
  }
  const cartPath = ((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || "/") + "cart";
  const isCartLink = url.origin === window.location.origin && (url.pathname === "/cart" || url.pathname === cartPath);

  // Blocca SOLO la pagina /cart, non i JS
  if (isCartLink || href === "https://www.miamily.com/cart") {
    e.preventDefault();
    return false;
  }
});
